function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'; // TODO: Change to height instead of pixels

var Spacer = function Spacer(props) {
  var _classnames;

  var m = props.m,
      mt = props.mt,
      mb = props.mb,
      ml = props.ml,
      mr = props.mr,
      mx = props.mx,
      my = props.my,
      className = props.className;
  var spacerClass = classnames((_classnames = {}, _defineProperty(_classnames, "m-".concat(m), m !== false), _defineProperty(_classnames, "mt-".concat(mt), mt !== false), _defineProperty(_classnames, "mb-".concat(mb), mb !== false), _defineProperty(_classnames, "ml-".concat(ml), ml !== false), _defineProperty(_classnames, "mr-".concat(mr), mr !== false), _defineProperty(_classnames, "mx-".concat(mx), mx !== false), _defineProperty(_classnames, "my-".concat(my), my !== false), _classnames), className);
  return React.createElement("div", {
    className: spacerClass,
    style: {
      height: '1px',
      width: '1px'
    }
  });
};

Spacer.propTypes = {
  /**
   * Additional classes to be added to the component
   */
  className: PropTypes.string,

  /**
   * Margin to be added to all sides.
   */
  m: PropTypes.number,

  /**
   * Margin to be added to top.
   */
  mt: PropTypes.number,

  /**
   * Margin to be added to bottom.
   */
  mb: PropTypes.number,

  /**
   * Margin to be added to left.
   */
  ml: PropTypes.number,

  /**
   * Margin to be added to right.
   */
  mr: PropTypes.number,

  /**
   * Margin only added to the x axis.
   */
  mx: PropTypes.number,

  /**
   * Margin only added to the y axis.
   */
  my: PropTypes.number
};
Spacer.defaultProps = {
  className: '',
  m: 0,
  mt: 0,
  mb: 0,
  ml: 0,
  mr: 0,
  mx: 0,
  my: 0
};
Spacer.displayName = 'Spacer';
export default Spacer;